import EventHandler from 'bootstrap/js/src/dom/event-handler.js';
import SelectorEngine from 'bootstrap/js/src/dom/selector-engine.js';

const EVENT_SLIDE = 'slide.bs.carousel';
const EVENT_SLID = 'slid.bs.carousel';
const SELECTOR_CAROUSEL = '.carousel';
const SELECTOR_INNER = '.carousel-inner';

const instances = new WeakMap();

class CarouselHeight {
  constructor(element) {
    this._element = element;
    this._inner = SelectorEngine.findOne(SELECTOR_INNER, element);
    if (this._inner) this._bindEvents();
    instances.set(element, this);
  }

  dispose() {
    EventHandler.off(this._element, EVENT_SLIDE);
    EventHandler.off(this._element, EVENT_SLID);
    instances.delete(this._element);
  }

  _bindEvents() {
    EventHandler.on(this._element, EVENT_SLIDE, (e) => this._onSlide(e));
    EventHandler.on(this._element, EVENT_SLID, () => this._onSlid());
  }

  _onSlide(e) {
    const nextSlide = e.relatedTarget;
    if (!nextSlide) return;
    this._inner.style.height = `${this._inner.offsetHeight  }px`;
    requestAnimationFrame(() => {
      this._inner.style.height = `${nextSlide.offsetHeight  }px`;
    });
  }

  _onSlid() {
    this._inner.style.height = '';
  }

  static getOrCreateInstance(element) {
    return instances.get(element) || new CarouselHeight(element);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  for (const el of SelectorEngine.find(SELECTOR_CAROUSEL)) {
    CarouselHeight.getOrCreateInstance(el);
  }
});

export default CarouselHeight;
